import { TimeRange } from 'features/systemLens'
import React from 'react'
import styled from 'styled-components'

const StyledLiveBadge = styled.span`
  flex-shrink: 0;
  margin-left: 0.25rem;
  display: inline-flex;
  align-items: center;
  padding: 0.125rem 0.5rem;
  border-radius: 0.25rem;
  background-color: #50c87836;
  color: #50c878;
  font-size: 0.625rem;
  font-weight: 700;
  text-transform: uppercase;
  font-variant: small-caps;
  font-feature-settings:
    'smcp' 1,
    'c2sc' 1;
  letter-spacing: 0.125em;
`

interface ActiveTimeRangeModeTagProps {
  liveTail?: boolean
  timeRange: TimeRange
}

export const ActiveTimeRangeModeTag: React.FC<ActiveTimeRangeModeTagProps> = ({
  liveTail,
}) => {
  if (liveTail === true) {
    return <StyledLiveBadge>Live</StyledLiveBadge>
  }
  return null
}
